import { graphqlPost } from "api/graphqlClient";
import autocompleteQuery from "components/Form/components/Autocomplete/Autocomplete.type";
import get from "lodash/get";
import { call, put, takeEvery } from "redux-saga/effects";
import {
    REQUEST_REFERENCE_LABELS,
    STORE_REFERENCE_LABELS,
} from "./ReferenceLabel.reducer";

// Keep a single batched query comfortably under the list `limit` cap (1000);
// screens rarely need more than a few hundred distinct references at once.
const CHUNK_SIZE = 500;

/**
 * Resolve a batch of (resource, ids) to display names in as few queries as
 * possible: one `{id in [...]}` query per CHUNK_SIZE ids, with allow_deleted so
 * references to trashed records still resolve (matching the single-id resolver
 * the read-only cells used before). Results are stored keyed by (resource, id).
 */
export function* fetchReferenceLabels({ resource, ids }) {
    if (!resource || !ids || ids.length === 0) {
        return;
    }
    for (let i = 0; i < ids.length; i += CHUNK_SIZE) {
        const chunk = ids.slice(i, i + CHUNK_SIZE);
        try {
            const filter = JSON.stringify({
                and: [{ field: "id", op: "in", value: chunk }],
            });
            const response = yield call(graphqlPost, {
                query: autocompleteQuery(resource, ""),
                variables: {
                    filter,
                    order: "+name",
                    limit: chunk.length,
                },
                allow_deleted: true,
            });
            const rows = get(response?.data, `${resource}_list.${resource}_list`, []);
            const labels = {};
            rows.forEach((row) => {
                if (row?.id != null) {
                    labels[row.id] = row.name;
                }
            });
            yield put({ type: STORE_REFERENCE_LABELS, resource, ids: chunk, labels });
        } catch (error) {
            // On failure resolve the chunk with empty labels: cells fall back to
            // the raw id (parity with the old per-cell behaviour) and we do not
            // retry-storm a degraded backend.
            yield put({ type: STORE_REFERENCE_LABELS, resource, ids: chunk, labels: {} });
        }
    }
}

export default [takeEvery(REQUEST_REFERENCE_LABELS, fetchReferenceLabels)];
